import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/components/LandingPage";
import AdminPanel from "@/components/AdminPanel";
import DestinationPage from "@/components/DestinationPage";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontFamily: "'JetBrains Mono', monospace",
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            fontSize: '12px',
            borderRadius: '0',
            border: '1px solid rgba(201, 164, 122, 0.45)',
            background: '#212a42',
            color: '#d8c7a5',
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/destination" element={<DestinationPage />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
